'use client';

import { useTranslations } from 'next-intl';
import { FilterPill } from '@terra/ui-design-system';
import { useDateFormatter } from '../../hooks/useDateFormatter';

type CreatedSinceFilterPillProps = {
  createdSince: Date | null;
  onClear: () => void;
};

export function CreatedSinceFilterPill({
  createdSince,
  onClear,
}: CreatedSinceFilterPillProps) {
  const tFilters = useTranslations('proxy.filters');
  const dateFormatter = useDateFormatter();

  if (!createdSince) {
    return null;
  }

  return (
    <FilterPill
      density="compact"
      readOnly
      isActive
      placeholder={tFilters('newSinceLastVisit')}
      selectedText={dateFormatter.format(createdSince)}
      onClear={(event) => {
        event.stopPropagation();
        event.preventDefault();
        onClear();
      }}
    />
  );
}
